export default __webpack_public_path__ + "static/media/about2title2.83e02491.png";